document.addEventListener("DOMContentLoaded", () => {
  const inlineMenus = document.querySelectorAll(".navigation-main-inline");

  inlineMenus.forEach((menu) => {
    const topLevelItems = menu.querySelectorAll(
      ":scope > .has-sub-menu:not(.navigation-item-static)",
    );

    topLevelItems.forEach((topItem) => {
      const topSubmenu = topItem.querySelector(":scope > .navigation-sub-menu:not(.mega-menu)");
      if (!topSubmenu) return;

      topItem.addEventListener("mouseleave", () => {
        const expandedItems = topSubmenu.querySelectorAll(".has-sub-menu.is-expanded");
        expandedItems.forEach((item) => {
          item.classList.remove("is-expanded");
          const icon = item.querySelector(":scope > a .navigation-item-icon");
          if (icon) icon.setAttribute("aria-expanded", "false");
        });

        topItem.classList.add("force-close");
        setTimeout(() => {
          topItem.classList.remove("force-close");
        }, 350);
      });

      const nestedSubmenus = topSubmenu.querySelectorAll(".has-sub-menu");

      nestedSubmenus.forEach((submenuItem) => {
        const link = submenuItem.querySelector(":scope > a");
        const childMenu = submenuItem.querySelector(":scope > .navigation-sub-menu");
        if (!link || !childMenu) return;

        const icon = link.querySelector(".navigation-item-icon");

        if (icon) {
          icon.setAttribute("tabindex", "0");
          icon.setAttribute("role", "button");
          icon.setAttribute("aria-expanded", "false");
          icon.setAttribute("aria-label", "Toggle submenu");
        }

        function toggleSubmenu(item) {
          const isExpanded = item.classList.contains("is-expanded");
          const itemIcon = item.querySelector(":scope > a .navigation-item-icon");

          const siblings = Array.from(item.parentElement.children).filter(
            (sibling) => sibling !== item && sibling.classList.contains("has-sub-menu"),
          );

          siblings.forEach((sibling) => {
            const siblingSubmenu = sibling.querySelector(":scope > .navigation-sub-menu");
            const siblingIcon = sibling.querySelector(":scope > a .navigation-item-icon");

            sibling.classList.remove("is-expanded");
            if (siblingIcon) siblingIcon.setAttribute("aria-expanded", "false");

            if (siblingSubmenu) {
              setTimeout(() => {
                siblingSubmenu.style.display = "";
              }, 50);
            }
          });

          if (!isExpanded) {
            item.classList.add("is-expanded");
            if (itemIcon) itemIcon.setAttribute("aria-expanded", "true");
          } else {
            item.classList.remove("is-expanded");
            if (itemIcon) itemIcon.setAttribute("aria-expanded", "false");
          }
        }

        link.addEventListener("click", (event) => {
          const href = link.getAttribute("href");
          const isHashLink = href === "#";
          const isIconClick = event.target.closest(".navigation-item-icon");

          if (isIconClick || isHashLink) {
            event.preventDefault();
            event.stopPropagation();
            toggleSubmenu(submenuItem);
          }
        });

        if (icon) {
          icon.addEventListener("keydown", (event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              event.stopPropagation();
              toggleSubmenu(submenuItem);
            }
          });
        }
      });
    });
  });
});
